<div class="modal-body text-center">
  <p [innerHTML]="text | safeHtml"></p>
  <div class="row">
      <div class="col-6 pe-2"><button type="button" class="btn btn-primary w-100" (click)="confirm()">Ja</button></div>
      <div class="col-6 ps-2"><button type="button" class="btn btn-warning w-100" (click)="decline()">Nee</button></div>
  </div>

</div>
